import { render, staticRenderFns } from "./organizationsSearch.vue?vue&type=template&id=6552cc16&scoped=true"
import script from "./organizationsSearch.vue?vue&type=script&lang=js"
export * from "./organizationsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6552cc16",
  null
  
)

export default component.exports